function hookScrollToDetails() {
  document.querySelectorAll("details").forEach((details) => {
    details.addEventListener("click", () => {
      if (!details.open) {
        setTimeout(() => {
          details.scrollIntoView({ block: "nearest" });
        }, 0);
        if (details.id) {
          history.replaceState(null, "", `#${details.id}`);
        }
      } else {
        if (details.id) {
          history.replaceState(null, "", `#`);
        }
      }
    });
  });
}

function openDetailsFromTarget() {
  const hash = location.hash;
  if (hash.startsWith("#") && hash.length > 1) {
    const targetDetails = document.getElementById(hash.slice(1));
    if (targetDetails instanceof HTMLDetailsElement) {
      targetDetails.open = true;
    }
  }
}

self.addEventListener("hashchange", openDetailsFromTarget);
openDetailsFromTarget();
hookScrollToDetails();
